import React, { useState, useEffect } from 'react';
import { getMarketStatus, formatPercent } from '../utils/formatters';
import { Circle } from '@phosphor-icons/react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function IndicesTicker() {
  const [indices, setIndices] = useState([]);
  const [marketStatus, setMarketStatus] = useState(getMarketStatus());

  useEffect(() => {
    const loadIndices = async () => {
      try {
        const { data } = await axios.get(`${API}/indices`, { withCredentials: true });
        setIndices(data);
      } catch {
        setIndices([]);
      }
    };
    loadIndices();
    const interval = setInterval(() => {
      loadIndices();
      setMarketStatus(getMarketStatus());
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-[#12141A] border border-white/10 p-4 mb-6" data-testid="indices-ticker">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-6 flex-wrap">
          {indices.map((idx) => (
            <div key={idx.symbol} className="flex flex-col" data-testid={`index-${idx.symbol}`}>
              <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#94A3B8] mb-1">
                {idx.name}
              </div>
              <div className="flex items-baseline gap-2">
                <span className="font-mono text-lg font-semibold text-white">
                  {idx.price.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
                <span className={`font-mono text-sm ${idx.change_percent >= 0 ? 'text-[#00FF66]' : 'text-[#FF3366]'}`}>
                  {formatPercent(idx.change_percent)}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 px-3 py-1.5 border border-white/10" data-testid="market-status">
          <Circle size={10} weight="fill" style={{ color: marketStatus.color }} className={marketStatus.status === 'open' ? 'animate-pulse' : ''} />
          <span className="text-xs font-mono uppercase tracking-[0.2em]" style={{ color: marketStatus.color }}>
            NSE • {marketStatus.label}
          </span>
        </div>
      </div>
    </div>
  );
}
